import { Controller, LoggedUser, Router, Tabs, global } from '@autoprog/core-client';

import C_Groups from '../tabs/Products.Groups';

import C_Categories from '../tabs/Products.Categories';
import T_Categories from '../../tpl/tabs/categories.html';

import C_Brands from '../tabs/Products.Brands';
import T_Brands from '../../tpl/tabs/brands.html';

import C_Tags from '../tabs/Products.Tags';
import T_Tags from '../../tpl/tabs/tags.html';

import C_Products from '../tabs/Products.Products';
import T_Products from '../../tpl/tabs/products.html';

import T_blockTabs from '@tpl/blocks/tabs.html';

import History from '@libs/History';

class ProductsCtrl extends Controller {
	private readonly TAB_LIST = ['products', 'groups', 'categories', 'brand', 'tags', undefined];

	constructor(el: HTMLElement, data: any, params: any) {
		super(el);

		params = params || {};

		const loggedUser = LoggedUser.getInstance();

		const defaultTab: typeof this.TAB_LIST[number] = this.getDefault(params.tabs, loggedUser);

		const navElement = el.querySelector('.tabs-container') as HTMLElement;

		const tabs = new Tabs({
			navElement,
			renderElement: el.querySelector('#page-content') as HTMLElement
		});

		//Gestion des permissions sur les uri pointant sur les onglets de la page
		if (defaultTab === 'products' && !loggedUser.hasPermission('PRODUCTS.SHOW')) {
			Router.getInstance().navigate('#403');
			return;
		} else if (defaultTab === 'groups' && !loggedUser.hasPermission('PRODUCTS._GROUPS.SHOW')) {
			Router.getInstance().navigate('#403');
			return;
		} else if (defaultTab === 'categories' && !loggedUser.hasPermission('PRODUCTS._CATEGORIES.SHOW')) {
			Router.getInstance().navigate('#403');
			return;
		} else if (defaultTab === 'brand' && !loggedUser.hasPermission('PRODUCTS._BRANDS.SHOW')) {
			Router.getInstance().navigate('#403');
			return;
		} else if (!this.TAB_LIST.includes(defaultTab)) {
			Router.getInstance().navigate('#404');
		}

		tabs.add({
			name: 'Produits',
			id: 'products',
			default: defaultTab === 'products',
			controller: C_Products,
			permission: 'PRODUCTS.SHOW',
			template: T_Products
		});

		if (!global.IS_MOBILE) {
			tabs.add({
				name: 'Groupes',
				id: 'groups',
				default: defaultTab === 'groups',
				controller: C_Groups,
				permission: 'PRODUCTS._GROUPS.SHOW',
				template: T_blockTabs
			});

			tabs.add({
				name: 'Catégories',
				id: 'categories',
				default: defaultTab === 'categories',
				controller: C_Categories,
				permission: 'PRODUCTS._CATEGORIES.SHOW',
				template: T_Categories
			});

			tabs.add({
				name: 'Marque',
				id: 'brand',
				default: defaultTab === 'brand',
				controller: C_Brands,
				permission: 'PRODUCTS._BRANDS.SHOW',
				template: T_Brands
			});

			tabs.add({
				name: 'Mots clés',
				id: 'tags',
				default: defaultTab === 'tags',
				controller: C_Tags,
				template: T_Tags
			});
		}

		let firstLoad = true;
		tabs.on('change', (data: { [key: string]: string }) => {
			if (firstLoad) {
				firstLoad = false;
			} else {
				History.getInstance().pushState(`/#module/apps/products/${data.id}`);
			}
		});
	}

	private getDefault(currentTabs: string | undefined, loggedUser: LoggedUser) {
		let defaultTab: typeof this.TAB_LIST[number] = currentTabs;

		if (loggedUser.hasPermission('PRODUCTS.SHOW')) {
			defaultTab = defaultTab || 'products';
		} else {
			if (!global.IS_MOBILE) {
				if (loggedUser.hasPermission('PRODUCTS._GROUPS.SHOW')) {
					defaultTab = defaultTab || 'groups';
				} else if (loggedUser.hasPermission('PRODUCTS._CATEGORIES.SHOW')) {
					defaultTab = defaultTab || 'categories';
				} else if (loggedUser.hasPermission('PRODUCTS._BRANDS.SHOW')) {
					defaultTab = defaultTab || 'brand';
				}
			}
		}

		if (!this.TAB_LIST.includes(defaultTab)) {
			Router.getInstance().navigate('#404');
		}

		return defaultTab;
	}

	public destructor() {

	}
}

export default ProductsCtrl;
